import { createTheme } from "@mui/material/styles";
import styled from "@emotion/styled";

export const OptionsWrapper = styled.div`
  margin-top: -40px;
  .MuiFormControlLabel-root {
    background-color: #e7f4ff;
    border-radius: 5px;
    margin-right: 0;
    margin-bottom: 8px;
    position: relative;
    height: 46px;
    margin-left: 0;
    .MuiFormControlLabel-label {
      align-items:center;
      display: flex;
      z-index: 1;
      svg {
        color: #1468a2;
      }
    }
    .MuiCheckbox-root {
      svg {
        display: none;
      }
      &.Mui-checked {
        position: absolute;
        width: 100%;
        height: 100%;
        &::after {
          content: "";
          background-color: #1468a2;
          border-radius: 5px;
          position: absolute;
          top: 0;
          left: 0;
          height: 100%;
          width: 100%;
        }
        & + .MuiFormControlLabel-label {
          color: #fff;
          margin-left: 18px;
          svg {
            color: #fff;
            path{fill:#fff}
          }
        }
      }
    }
  }
`;
export const theme = createTheme({
    palette: {
        primary: {
            main: "#1468A2",
        },
    },
    typography: {
        fontFamily: ["Poppins, sans-serif"].join(","),
        variants: [],
    },
    components: {
        MuiButton: {
            styleOverrides: {
                // Name of the slot
                root: {
                    fontSize: "1rem",
                    padding: "9.2px 15px",
                    textTransform: "none",
                },
            },
            variants: [
                {
                    props: { variant: "contained" },
                    style: {
                        backgroundColor: "#1468A2",
                        width: "240px",
                        "&:hover": {
                            backgroundColor: "#1468A2",
                            color: "#fff",
                        },
                    },
                },
            ],
        },
    },
});
theme.typography.h2 = {
    fontSize: 28,
    fontWeight: 600,
    color: "#1468A2",
    lineHeight: "36px",
    marginBottom: "18px",
    position: "relative",
    top: "-110px",
    height: "72px",
    ["@media (max-width:767px)"]: { top: "-140px", },
};
theme.typography.h3 = {
    fontSize: 16,
    fontWeight: 500,
    color: "#666",
    marginBottom: "1rem",
};